var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.imgList, function(obj2, key) {
        return _c("img", {
          key: key,
          staticStyle: {
            "max-width": "80px",
            border: "2px solid #dcdcdc",
            "font-size": "12px",
            "font-style": "italic",
            cursor: "pointer"
          },
          attrs: { src: obj2.src, height: "25px", width: "50px", alt: "" },
          on: {
            click: function($event) {
              return _vm.handleImgView(obj2.src)
            }
          }
        })
      }),
      _c(
        "a-modal",
        {
          attrs: {
            mask: false,
            width: 1000,
            title: "圖片詳情",
            visible: _vm.previewVisible,
            "confirm-loading": false,
            "ok-button-props": { props: { disabled: true } },
            cancelText: "關閉"
          },
          on: { cancel: _vm.handleCancel }
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { alt: "example", src: _vm.previewImage }
          })
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }